module.exports = __webpack_public_path__ + "public/b0505cc47f6d535cc832be4a6a85f118.svg";